const getFacets = (response: any, facetName: string) => {
  const facets = response?.results?.[0]?.facets[facetName];

  if (!facets) {
    return [];
  }

  return Object.keys(facets).map((key: string) => {
    return {
      title: key,
      value: key.toLowerCase(),
    };
  });
};

export default getFacets;
